import { ItemPrerolls } from 'DVWebNodeUtils'
import { logError } from './csm';

export default function fireDraperTrackingEvent(prerolls: ItemPrerolls, eventName: string) {
  const eventUrl = prerolls &&
    prerolls.trackingEvents &&
    prerolls.trackingEvents[eventName]
  if (eventUrl) {
    // not using APIClient here, as the CORS settings of the Draper endpoints
    // prohibit using {credentials: include}
    fetch(eventUrl).catch((er) =>
      logError(er, "Error firing Draper tracking event"))
  }
}
